module.exports = __webpack_public_path__ + "static/testing-5da8cda81d37fc61108a5188b271ef5b.webp";